module.exports = __webpack_public_path__ + "static/img/banner_bg.6c41abd3.png";